import { ExtrasEditModal } from '../ExtrasEditModal';
import type { ExtrasEditModalType } from '../ExtrasEditModal';
import { GuestSelectModal } from '../GuestSelectModal';
import type { ExtrasModalsProps } from './ExtrasModals.types';

export function ExtrasModals({
  selection,
  items,
  guests,
  currencyCode,
  locale,
  labels,
}: ExtrasModalsProps) {
  const {
    modalTitle,
    modalConfirm,
    modalClose,
    modalTotal,
    dateModalTitle,
    dateRangeModalTitle,
    timeRangeModalTitle,
    dateTimeModalTitle,
    dateTimeRangeModalTitle,
    quantityModalTitle,
    applyToAll,
    perUnit,
    perGuest,
    weekdays,
    previousWeek,
    nextWeek,
    timesLabel,
  } = labels;

  const {
    isMultiGuest,
    modalItemId,
    modalGuests,
    editModalItemId,
    handleToggleModalGuest,
    handleConfirmModal,
    handleCloseModal,
    handleConfirmEditModal,
    handleCloseEditModal,
  } = selection;

  const modalItem = modalItemId ? items.find((i) => i.id === modalItemId) : null;
  const editModalItem = editModalItemId ? items.find((i) => i.id === editModalItemId) : null;

  const editModalType: ExtrasEditModalType | null = editModalItem
    ? editModalItem.type === 'per_stay'
      ? 'quantity'
      : (editModalItem.type as ExtrasEditModalType)
    : null;

  const editModalTitles: Partial<Record<ExtrasEditModalType, string | undefined>> = {
    per_date: dateModalTitle,
    per_date_range: dateRangeModalTitle,
    per_time_range: timeRangeModalTitle,
    per_date_time: dateTimeModalTitle,
    per_date_time_range: dateTimeRangeModalTitle,
    quantity: quantityModalTitle,
  };

  return (
    <>
      {isMultiGuest && (
        <GuestSelectModal
          open={modalItemId !== null}
          onClose={handleCloseModal}
          guests={modalGuests}
          onToggleGuest={handleToggleModalGuest}
          onConfirm={handleConfirmModal}
          extraTitle={modalItem?.title}
          currencyCode={currencyCode}
          locale={locale}
          labels={{
            title: modalTitle,
            confirm: modalConfirm,
            close: modalClose,
            total: modalTotal,
          }}
        />
      )}
      {editModalItem && editModalType && (
        <ExtrasEditModal
          key={editModalItem.id}
          open
          onClose={handleCloseEditModal}
          type={editModalType}
          extraTitle={editModalItem.title}
          options={editModalItem.options}
          guests={
            isMultiGuest && (editModalItem.perPerson ?? false) && editModalType !== 'quantity'
              ? guests
              : undefined
          }
          perPerson={editModalItem.perPerson ?? false}
          initialSelections={editModalItem.selectedOptions}
          initialApplyToAll={editModalItem.appliedToAllGuests}
          unitPrice={{
            amount: editModalItem.price.amount,
            currencyCode: editModalItem.price.currencyCode,
          }}
          maxQuantity={editModalItem.maxQuantity}
          initialQuantity={editModalItem.quantity ?? 1}
          rangeLabel={editModalItem.rangeLabel}
          currencyCode={currencyCode}
          locale={locale}
          onConfirm={handleConfirmEditModal}
          labels={{
            title: editModalTitles[editModalType],
            close: modalClose,
            total: modalTotal,
            confirm: modalConfirm,
            applyToAll,
            perUnit,
            perGuest,
            weekdays,
            previousWeek,
            nextWeek,
            timesLabel,
          }}
        />
      )}
    </>
  );
}
